"use strict";

const style = require("!!css-loader!./style/index.css").default;
const PREVIOUS_NEXT = require("./previous_next");

module.exports =`
<style>${style}</style>
<ul class="swiftref-pagination">
    ${PREVIOUS_NEXT}
</ul>
<div>
    <div>Results per page</div>
    <swiftref-dropdown kind="compact">
            <option slot="option" value="10">10</option>
            <option slot="option" value="20">20</option>
            <option slot="option" value="50">50</option>
            <option slot="option" value="100">100</option>
    </swiftref-dropdown>
</div>
`;
